module.exports = __webpack_public_path__ + "img/arrow-left.293e0109.svg";